export const enumContextContratMultiSelect = {
    PROFILETUDIANT : "ProfilEtudiant",
    ANNONCEINTERNE : "AnnonceInterne",
    RECHERCHEAFFINEE : "RechercheAffinee"
}